import React, { FC, memo } from 'react';
import MassagePushConfiguration from 'src/components/pages/components/massage-push-configuration';
import { AutoMatePushConf } from 'src/api/types';

export interface TemplateProps {
    value?: {
        checkedTypes?: number[];
        pushConf?: AutoMatePushConf[];
    };
    onChange?: (v: TemplateProps['value']) => void;
    [key: string]: unknown;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, ...restProps } = props;

    const onPushTypesChange = (v) => {
        onChange?.({
            ...value,
            checkedTypes: v,
            pushConf: value?.pushConf?.map((c) => {
                return {
                    ...c,
                    enabled: v.includes(c.actionType) ? 1 : 0,
                };
            }),
        });
    };

    const onPushConfChange = (v) => {
        onChange?.({
            ...value,
            pushConf: v,
        });
    };

    return (
        <MassagePushConfiguration
            checkedTypes={value?.checkedTypes}
            onPushTypesChange={onPushTypesChange}
            pushConf={value?.pushConf}
            onPushConfChange={onPushConfChange}
            {...restProps}
        />
    );
});

export default Template;
